import { useState } from "react";
import { authApi, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

// Form state + validation + submit for the change-password dialog.
export function useChangePasswordForm() {
  const [open, setOpen] = useState(false);
  const [cur, setCur] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const reset = () => { setCur(""); setNext(""); setConfirm(""); };
  const onOpenChange = (o) => { setOpen(o); if (!o) reset(); };

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 8) { toast.error("New password must be at least 8 characters."); return; }
    if (next !== confirm) { toast.error("New passwords do not match."); return; }
    setLoading(true);
    try {
      await authApi.changePassword({ current_password: cur, new_password: next });
      toast.success("Password changed");
      reset();
      setOpen(false);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Could not change the password.");
    } finally {
      setLoading(false);
    }
  };

  return { open, onOpenChange, cur, setCur, next, setNext, confirm, setConfirm, loading, submit };
}
